import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export type RecoveryScope = 'all_tenants' | 'tenant' | 'file';

type ReprocessEmptyWrangledPayload = {
  scope: RecoveryScope;
  tenantName?: string;
  fileId?: string;
  dryRun: boolean;
  sinceDate?: string | null;
  delaySeconds?: number;
};

type TenantCandidateCount = { tenantName: string; count: number };

export type ReprocessEmptyWrangledResponse = {
  dryRun: boolean;
  started: boolean;
  totalCandidates: number;
  tenants: TenantCandidateCount[];
};

export const useReprocessEmptyWrangled = () => {
  const { mutateAsync, isPending } = useMutation<
    { data: ReprocessEmptyWrangledResponse },
    Error,
    ReprocessEmptyWrangledPayload
  >({
    mutationFn: payload =>
      api.post<ReprocessEmptyWrangledResponse>(
        'admin/data-upload-files/reprocess-empty-wrangled',
        payload,
      ),
  });

  return { reprocess: mutateAsync, isReprocessing: isPending };
};
